/* template */
<template><page><mpx-scroll-view :class='["swipe-demo"]'><div :class='["swipe-switch"]'><div :class='[("swipe-switch-btn "+(currentType === "default" ? "swipe-switch-btn_active" : ""))]' @tap='(e)=>__invoke(e, [["showDefault"]])'>Default Swipe</div><div :class='[("swipe-switch-btn "+(currentType === "custom" ? "swipe-switch-btn_active" : ""))]' @tap='(e)=>__invoke(e, [["showCustom"]])'>Custom Swipe</div></div><div :class='["swipe-demo-title"]' v-if="(currentType === 'default')">Default Swipe</div><div v-if="(currentType === 'default')"><default-swipe></default-swipe></div><div :class='["swipe-demo-title"]' v-if="(currentType === 'custom')">Custom Swipe</div><div v-if="(currentType === 'custom')"><custom-swipe></custom-swipe></div></mpx-scroll-view></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_cf97d5b0"}'>
.swipe-demo
  margin-top: 8px
.swipe-switch
  display flex
  padding 0 10px 10px
.swipe-switch-btn
  flex 1
  height 32px
  line-height 32px
  text-align center
  border 1px solid #ddd
  background #fff
  color #666
  &:first-child
    border-right none
.swipe-switch-btn_active
  color #fc9153
  border-color #fc9153
.swipe-demo-title
  padding 5px 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_cf97d5b0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_cf97d5b0"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_cf97d5b0"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'custom-swipe':getComponent(require("./custom-swipe.mpx?isComponent&outputPath=components%2Fcustom-swipe9993b994%2Findex")),'default-swipe':getComponent(require("./default-swipe.mpx?isComponent&outputPath=components%2Fdefault-swipeb24857f8%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>